import { Ankh } from "@/components/guide-public/guide-ornaments";
import type { GuideLang } from "@/lib/virtualspace/guide/guide-public-shape";

/**
 * A section heading: eyebrow (with the section numeral), the title, and its
 * twin in the other language, which is the Guide's bilingual signature.
 */
export function SectionHead({
  id,
  numeral,
  eyebrow,
  title,
  twin,
  lang,
}: {
  id: string;
  numeral: string;
  eyebrow: string;
  title: string;
  twin: string;
  lang: GuideLang;
}) {
  const twinLang = lang === "ar" ? "en" : "ar";
  return (
    <div className="eg-section-head">
      <p className="eg-eyebrow">
        {numeral} · {eyebrow}
      </p>
      <div className="eg-section-head__titles">
        <h2 id={id}>{title}</h2>
        <span className="eg-section-head__twin" lang={twinLang} dir={twinLang === "ar" ? "rtl" : "ltr"}>
          {twin}
        </span>
      </div>
    </div>
  );
}

/**
 * A venue photo, or a lapis panel with an ankh when the venue has none yet.
 * Plain <img>: covers are signed storage links or files from /public, sized
 * by their frame.
 */
export function GuidePhoto({
  src,
  alt,
  label,
  style,
  loading = "lazy",
}: {
  src: string | null;
  alt: string;
  label: string;
  style?: React.CSSProperties;
  loading?: "lazy" | "eager";
}) {
  if (!src) {
    return (
      <div className="eg-photo-missing" style={style} role="img" aria-label={alt}>
        <span style={{ color: "var(--eg-gold-on-lapis)" }}>
          <Ankh size={44} />
        </span>
        <span className="eg-display" style={{ fontSize: 22 }}>
          {label}
        </span>
      </div>
    );
  }
  // eslint-disable-next-line @next/next/no-img-element
  return <img src={src} alt={alt} loading={loading} decoding="async" style={style} />;
}
